import Advice from "components/common/Advice";

const CnpHoldingAdvice = () => (
  <Advice
    title={"Há mais de 20 anos cuidando dos  momentos de vida das pessoas"}
    paragraph={
      <>
        Em 2001, iniciamos nossa operação no Brasil, em uma parceria histórica e rentável com a Caixa.
        Juntos, criamos a terceira maior seguradora do País: a Caixa Seguradora, que cuidou e trouxe soluções
        para milhões de brasileiros.
        <br /><br />
        Atualmente, administramos os negócios da Caixa Seguradora por meio de uma
        valiosa carteira de produtos que inclui o seguro habitacional e a plataforma digital Youse,
        primeira de seguros 100% online do País. Contamos também com o Instituto CNP Brasil como um braço de atuação social.
      </>
    }
  />
);
export default CnpHoldingAdvice;
